import { useNavigate, useLocation } from "react-router-dom";
import { Logo, Wordmark } from "./Logo";
import { scrollToId } from "./SmoothScroll";

const LINKS = [
  ["problem", "Problem"],
  ["consequences", "Consequences"],
  ["how", "How it works"],
  ["domains", "Domains"],
  ["api", "API"],
];

const DEMO_URL = process.env.REACT_APP_DEMO_URL || "/demo";
const DEMO_EXTERNAL = /^https?:\/\//.test(DEMO_URL);

export const Nav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const go = (id) => (e) => {
    e.preventDefault();
    if (location.pathname === "/") scrollToId(id);
    else navigate("/#" + id);
  };

  return (
    <header className="nav-bar">
      <div className="wrap nav">
        <a className="brand" href="/" data-testid="nav-brand"
          onClick={(e) => { e.preventDefault(); navigate("/"); window.scrollTo(0, 0); }} aria-label="VeriAuth home">
          <Logo w={50} h={42} /> <Wordmark size={25} />
        </a>
        <nav className="links" aria-label="Primary">
          {LINKS.map(([id, label]) => (
            <a key={id} href={"/#" + id} onClick={go(id)} data-testid={`nav-${id}`}>{label}</a>
          ))}
          <a href="/scan" style={{ color: "var(--green)" }} data-testid="nav-veriscan"
            onClick={(e) => { e.preventDefault(); navigate("/scan"); }}>VeriScan</a>
          <a href={DEMO_URL} style={{ color: "var(--cyan)" }} data-testid="nav-demo"
            {...(DEMO_EXTERNAL ? { target: "_blank", rel: "noopener noreferrer" } : { onClick: (e) => { e.preventDefault(); navigate("/demo"); } })}>Demo</a>
        </nav>
        <span className="spacer" />
        <a className="btn" href="/#test" data-testid="nav-cta"
          onClick={(e) => { e.preventDefault(); location.pathname === "/" ? scrollToId("test") : navigate("/#test"); }}>
          Test your AI →
        </a>
      </div>
    </header>
  );
};
